import * as React from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import { SRPRS } from 'components/_Assets/svg/Icon/srprs'
import { ActionList } from 'components/ActionList'
import { BlockItem, BlockSelect, BlockSelectType } from 'components/BlockSelect'
import Box, { BoxType } from 'components/Box'
import { Button, TYPE } from 'components/Button'
import NumberFlipclock from 'components/Flipclock/NumberFlipclock'
import { Col, Grid } from 'components/Grid'
import Heading from 'components/Heading'
import Hero from 'components/Hero'
import { HeroType } from 'components/Hero/Hero'
import { InfoBox, InfoBoxItem } from 'components/InfoBox/InfoBox'
import ListHeader from 'components/ListHeader'
import Photo from 'components/Photo'
import Section, { SectionType, Size } from 'components/Section/Section'
import Style from 'components/Style'
import { Timeline, TimelineItem } from 'components/Timeline'
import { getCdnUrl } from '../../data/api/cdn'
import { EntryProps } from '../../data/entries/types'
import { City } from '../../data/models/funnelOrder/cities'
import { destinationEnum } from '../../data/models/funnelOrder/destination'
import { roomType } from '../../data/models/funnelOrder/roomType'
import { SiteCountry, SiteCurrency } from '../../data/models/locale'
import { AppState } from '../../data/state'
import { FunnelStep } from '../../data/ui'
import Calendar from '../../elements/Calendar'
import IfCountry from '../../elements/conditionals/IfCountry'
import FunnelFooter from '../../elements/footers/funnelFooter'
import FunnelBreadcrumbs from '../../elements/FunnelBreadcrumbs'
import GiftcardModal from '../../elements/modals/GiftcardModal'
import PersonModal from '../../elements/modals/PersonModal'
import TextTooltip from '../../elements/tooltips/textTooltip'
import { getNameWithTheme, getParamsWithTheme } from '../../routing/links'
import AirportComponent from '../funnel/customise/options/airport'
import FlyExcluded from '../funnel/customise/options/flyExcluded'
import People from '../funnel/customise/options/people'
import { QueryKey } from '../funnel/customise/wrapper'
import {
  CustomiseWrapperInnerProps,
  withAirportsAndPrices,
} from '../funnel/customise/wrapperFunction'
import DisplayContent from '../shared/content'
import Page from '../shared/page_wrapper'
import BasicInfo from './components/basicInfo'
import FAQ from './components/faq'
import FlavourBox from './components/flavourBox'
import HowItWorks from './components/howItWorks'

interface BrokePageStateProps {
  destination: destinationEnum
  total: number
  patternImage: string
  roomtype: number
  country: SiteCountry
  currency: SiteCurrency
  excludedCities: City[]
}

interface BrokePageDispatchProps {
  setExcludedCities(cities: City[]): void
  setRoomType(theRoomType: roomType): void
  setYearAndMonth(year: number, month: number): void
}

interface BrokePageProps
  extends BrokePageStateProps,
    BrokePageDispatchProps,
    CustomiseWrapperInnerProps,
    EntryProps {}

class BrokePage extends React.Component<BrokePageProps> {
  private infoSection?: HTMLDivElement
  private detailsSection?: HTMLDivElement

  public componentDidMount() {
    const hash = window.location.hash
    if (hash !== undefined && hash === '#steden') {
      setTimeout(() => {
        if (this.detailsSection) {
          this.detailsSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          })
        }
      }, 2000)
    } else {
      window.scrollTo(0, 0)
    }

    switch (this.props.country) {
      case SiteCountry.nl:
        this.props.setYearAndMonth(2020, 3)
        break
      case SiteCountry.be:
        this.props.setYearAndMonth(2020, 3)
        break
      case SiteCountry.uk:
        this.props.setYearAndMonth(2020, 3)
        break
      default:
        this.props.setYearAndMonth(2020, 3)
    }
  }

  public render() {
    const {
      entry,
      match,
      prices,
      loading,
      currency,
      airports,
      patternImage,
      roomtype,
    } = this.props
    const pattern = getCdnUrl('feelingLuckyWavesBg.png')

    if (entry.page === undefined) {
      throw new Error('No page properties')
    }

    let countrySlug = ''
    let slugAddon = ''
    switch (this.props.country) {
      case SiteCountry.uk:
        countrySlug = '-uk'
        slugAddon += '-uk'
        break
      case SiteCountry.ie:
        countrySlug = '-ie'
        slugAddon += '-ie'
        break
    }

    return (
      <Page
        match={match}
        page={entry.page.name}
        color={entry.colour}
        navBarType="funnel"
        navBarOverrideColour={
          entry.page.style ? entry.page.style.navbarColor : undefined
        }
        navFooter
      >
        <Hero
          type={HeroType.flavourEntry}
          headingColor={
            entry.page.style ? entry.page.style.headingColor : undefined
          }
          headingText={
            <DisplayContent contentKey="title">{entry.name}</DisplayContent>
          }
          subHeading={<FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />}
          src={entry.page.photos.src}
          src768={entry.page.photos.src768}
          src1024={entry.page.photos.src1024}
          src1280={entry.page.photos.src1280}
          src1600={entry.page.photos.src1600}
          src1920={entry.page.photos.src1920}
        >
          <FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />
          <Heading level={1}>
            <DisplayContent contentKey="title">{entry.name}</DisplayContent>
          </Heading>
          <InfoBox>
            <InfoBoxItem
              icon={SRPRS.calendarMonth}
              firstLine={
                <DisplayContent contentKey={`1-info-top${slugAddon}`}>
                  3 Dagen
                </DisplayContent>
              }
            />
            <InfoBoxItem
              icon={SRPRS.bed}
              firstLine={
                <DisplayContent contentKey="2-info-top">
                  hotel of
                </DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="2-info-bottom">
                  hostel
                </DisplayContent>
              }
            />
            <InfoBoxItem
              icon={SRPRS.mapMarker}
              firstLine={
                <DisplayContent contentKey="3-info-top">Heel</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="3-info-bottom">
                  Europa
                </DisplayContent>
              }
            />
          </InfoBox>
        </Hero>
        <BasicInfo
          detailsScroll={this.handleDetailsScroll}
          infoScroll={this.handleInfoScroll}
          contentKeySlug={countrySlug}
          nrItems={4}
        />
        <Section type={SectionType.solid}>
          <Box type={BoxType.pattern} patternImage={pattern}>
            <Heading
              level={3}
              subHeading={
                <DisplayContent contentKey="box-sub-heading">
                  I will be fast
                </DisplayContent>
              }
            >
              <DisplayContent contentKey="box-heading">
                For you the knowledge is the way
              </DisplayContent>
            </Heading>
            <p>
              <DisplayContent contentKey="box-blurb">
                This citytrip is only available for a short amount of time. So
                short that you probably couldn't find 147 other people similar
                to you. So this is a great opportunity to try this distinct
                flavour. What are you waiting?
              </DisplayContent>
            </p>

            <Grid nrCols={[1, 2, 2, 2]}>
              <Col className={`box-countdown-number`}>
                <p>
                  <DisplayContent contentKey="box-counter-pre">
                    NOG
                  </DisplayContent>
                </p>
                <NumberFlipclock
                  startValue={entry.countDownStartNumber || 120}
                  currentValue={
                    entry.countDownNumber || entry.countDownStartNumber || 120
                  }
                />
                <p>
                  <DisplayContent contentKey="box-counter-post">
                    OVER
                  </DisplayContent>
                </p>
              </Col>
            </Grid>
          </Box>
        </Section>
        <Section type={SectionType.solid} size={Size.s}>
          <Style margin={[[0, 0, 20, 0]]}>
            <div ref={this.setDetailsRef} />
            <Timeline direction="vertical" numbers>
              <TimelineItem>
                <Heading level={3}>
                  <DisplayContent contentKey="type-heading">
                    Choose your ideal srrps.summerholiday?
                  </DisplayContent>
                </Heading>
                <BlockSelect
                  model="roomType"
                  nrCols={[1, 2]}
                  type={BlockSelectType.card}
                  value={roomtype}
                  onChange={this.changeRoomType}
                >
                  <BlockItem
                    label={
                      <DisplayContent contentKey="hostel-label">
                        Hostel
                      </DisplayContent>
                    }
                    value={1}
                    labelSubline={
                      <>
                        <Style margin={[[0, 0, 10, 0]]}>
                          <DisplayContent contentKey="hostel-blurb">
                            5 days relaxing on the beach with a cocktail in hand
                          </DisplayContent>
                        </Style>
                        <DisplayContent contentKey="hostel-story-1">
                          5 days
                        </DisplayContent>
                        <br />
                        <DisplayContent contentKey="hostel-story-2">
                          1 accomodation
                        </DisplayContent>
                        <br />
                        <DisplayContent contentKey="hostel-story-3">
                          Seaside destination
                        </DisplayContent>
                      </>
                    }
                    footerText={
                      <DisplayContent
                        contentKey="hostel-from"
                        vars={{ currency, price: `139` }}
                      >
                        {`From ${currency} ${139} p.p`}
                      </DisplayContent>
                    }
                    footerButton={
                      <TextTooltip
                        contentKey="roomType-budget-info-content"
                        placeholder="Shared accomodation info"
                      >
                        <Button type={TYPE.info} negative={true} />
                      </TextTooltip>
                    }
                    illustration={
                      <Photo
                        alt="Blam!"
                        src={getCdnUrl('Blam2x.jpg')}
                        backgroundImage
                      />
                    }
                  />
                  <BlockItem
                    label={
                      <DisplayContent contentKey="hotel-label">
                        Hotel
                      </DisplayContent>
                    }
                    value={2}
                    labelSubline={
                      <>
                        <Style margin={[[0, 0, 10, 0]]}>
                          <DisplayContent contentKey="hotel-blurb">
                            Discover a city for 3 days and then relax on the
                            beach for 4 days
                          </DisplayContent>
                        </Style>
                        <DisplayContent contentKey="hotel-story-1">
                          7 days
                        </DisplayContent>
                        <br />
                        <DisplayContent contentKey="hotel-story-2">
                          2 accomodations
                        </DisplayContent>
                        <br />
                        <DisplayContent contentKey="hotel-story-3">
                          City and Sea
                        </DisplayContent>
                      </>
                    }
                    footerText={
                      <DisplayContent
                        contentKey="hotel-from"
                        vars={{ currency, price: `169` }}
                      >
                        {`From ${currency} ${169} p.p.`}
                      </DisplayContent>
                    }
                    footerButton={
                      <TextTooltip
                        contentKey="hotel-info-content"
                        placeholder="Shared accomodation info"
                      >
                        <Button type={TYPE.info} negative={true} />
                      </TextTooltip>
                    }
                    illustration={
                      <Photo
                        alt="Pop art talk"
                        src={getCdnUrl('Pop-art_talk2x.jpg')}
                        backgroundImage
                      />
                    }
                  />
                </BlockSelect>
              </TimelineItem>
              <TimelineItem>
                <div className="margin-b-m">
                  <ActionList>
                    <People />
                    <FlyExcluded max={1} />
                    <IfCountry country={SiteCountry.uk}>
                      <AirportComponent {...{ airports, noTimes: true }} />
                    </IfCountry>
                  </ActionList>
                </div>
                <Box fullWidthMobile>
                  <Calendar
                    actionList
                    hideTrigger
                    showCheapest={false}
                    prices={prices}
                    loading={loading}
                  />
                </Box>
              </TimelineItem>
            </Timeline>
          </Style>
          <PersonModal />
        </Section>
        <FunnelFooter
          nextStepNo={2}
          nextStepLink={getNameWithTheme('extras')}
          nextStepLinkParams={getParamsWithTheme()}
          nextStepName={
            <DisplayContent edit={true} contentKey="extras">
              Extras
            </DisplayContent>
          }
          stickyStop
          nextStepDisabled={isNaN(this.props.total)}
        />
        <GiftcardModal />
        <FlavourBox
          patternImage={patternImage}
          setInfoRef={this.setInfoRef}
          content={entry.page.content}
        />
        <HowItWorks />
        <Section type={SectionType.white}>
          <ListHeader noMarginBottom>
            <Button cutOff="left" onClick={this.handleDetailsScroll}>
              <DisplayContent contentKey="boek-direct" edit={true}>
                Boek direct
              </DisplayContent>
            </Button>
          </ListHeader>
        </Section>
        <FAQ nrItems={3} />
      </Page>
    )
  }

  private changeRoomType = (roomtype: string) => {
    this.props.setRoomType(+roomtype)
  }

  private setInfoRef = (ref: HTMLDivElement) => {
    this.infoSection = ref
  }

  private setDetailsRef = (ref: HTMLDivElement) => {
    this.detailsSection = ref
  }

  private handleInfoScroll = () => {
    if (this.infoSection) {
      this.infoSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  private handleDetailsScroll = () => {
    if (this.detailsSection) {
      this.detailsSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
}

const ConnectedBrokePage = connect<
  BrokePageStateProps,
  BrokePageDispatchProps,
  {},
  AppState
>(
  state => ({
    destination: state.funnelOrder.destination,
    total: state.funnelOrder.total,
    patternImage: state.page.patternImage,
    roomtype: state.funnelOrder.roomType,
    country: state.locale.country,
    currency: state.locale.currency || SiteCurrency.euro,
    excludedCities: state.funnelOrder.excludedCitiesIds,
  }),
  dispatch => ({
    setExcludedCities: cities => {
      dispatch(actions.change('funnelOrder.excludedCitiesIds', cities))
    },
    setRoomType: (theRoomType: roomType) => {
      dispatch(actions.change('funnelOrder.roomType', theRoomType))
    },
    setYearAndMonth: (year: number, month: number) => {
      dispatch(actions.change('funnelOrder.year', year))
      dispatch(actions.change('funnelOrder.month', month))
    },
  }),
)(BrokePage)

export default withAirportsAndPrices<EntryProps>(ConnectedBrokePage, [
  QueryKey.month,
  QueryKey.year,
])
